import { useRef } from 'react';

import Box from '@mui/material/Box';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import useSharedUppyInstance from '@webclient/components/search-forms/gamification-search/hooks/useSharedUppyInstance';

import UploadRoundedIcon from '~icons/knowz-iconify/upload-rounded';

import { Text } from '@knowz/knowz-ui';
import { useTranslate } from '@tolgee/react';
import { Meta } from '@uppy/core';
import { FileInput } from '@uppy/react';

export default function UploadAFile() {
  const { t } = useTranslate();

  const { uppy } = useSharedUppyInstance();

  const inputRef = useRef<FileInput<Meta, Record<string, never>> | null>(null);

  const handleTriggerFileInputProgrammatically = () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    /* @ts-expect-error */ // TODO: fix types
    inputRef.current?.plugin?.handleClick();
  };

  return (
    <ListItemButton
      disableGutters
      disableRipple
      onClick={handleTriggerFileInputProgrammatically}
      disableTouchRipple
    >
      <ListItemIcon>
        <UploadRoundedIcon />
      </ListItemIcon>
      <ListItemText
        primary={
          <Text
            variant="textSm"
            weight="semibold"
          >
            {t('layout.searchWidget.attachments.uploadFiles', 'Upload files')}
          </Text>
        }
      />
      <Box
        aria-hidden="true"
        sx={{ display: 'none' }}
      >
        <FileInput
          pretty={true}
          uppy={uppy}
          ref={inputRef}
        />
      </Box>
    </ListItemButton>
  );
}
